var r=function(r,n,t,a){var e=-1,l=null==r?0:r.length;for(a&&l&&(t=r[++e]);++e<l;)t=n(t,r[e],e,r);return t};export{r as _};
//# sourceMappingURL=_arrayReduce.js.map
